export default {"src":"/_next/static/media/zoning_2.e8b49e40.gif","height":400,"width":700,"blurWidth":0,"blurHeight":0};